import { RequestService } from '../../../../../common/services/RequestService';
import { PARKING_GET } from '../../constants';

export const getParkingRequest = payload => {
  return RequestService.get(PARKING_GET);
};
